import produce, { Draft } from 'immer';
import { cloneDeep, get, omit, without } from 'lodash';
import { Query } from 'redux-little-router';

import { Action } from '../actions';
import {
    CHANGE_COPIED_DISPLAY_CONDITIONS_TOOLTIP_STATUS,
    ON_CHANGE_OPEN_STATE_DISPLAY_CONDITIONS,
    ON_CHANGE_TEXT_TYPE_VIEW_DISPLAY_CONDITIONS,
    ON_ERROR_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS,
    ON_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS,
    ON_START_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS
} from '../actions/banners-edit/banner-edit-display-conditions';
import { UPLOAD_AD_BANNER_IMAGES } from '../actions/banners-edit/banner-image';
import {
    CLEAR_SITE_LINKS,
    ClearSiteLinks,
    CLOSE_SITE_LINKS_EDITOR,
    CloseSiteLinksEditor,
    OPEN_SITE_LINKS_EDITOR,
    OpenSiteLinksEditor,
    RESET_SITE_LINKS,
    ResetSiteLinks,
    SAVE_SITE_LINKS_SUCCESS,
    SaveSiteLinksSuccess,
    SHOW_SITE_LINKS_ERRORS,
    UPDATE_DRAFT_SITE_LINKS,
    UpdateDraftSiteLinks
} from '../actions/banners-edit/banner-sitelinks';
import {
    SHOW_BANNER_IMAGE_CREATIVE_UPLOAD_ERROR,
    SHOW_BANNER_IMAGE_LINK_INPUT,
    UPDATE_BANNER_IMAGE,
    UPDATE_BANNER_IMAGE_BY_GALLERY,
    UPDATE_BANNER_IMAGE_CREATIVE
} from '../actions/banners-edit/banner-text-image';
import {
    ACCEPT_MASS_ACTIONS_CALLOUTS,
    ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR,
    ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE,
    ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR,
    SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR,
    SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR,
    SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR
} from '../actions/banners-edit/banners-edit-mass-actions';
import {
    CLOSE_CALLOUTS_EDITOR,
    CloseCalloutsEditor,
    OPEN_CALLOUTS_EDITOR,
    OpenCalloutsEditor,
    SAVE_CALLOUTS,
    SaveCallouts
} from '../actions/banners-edit/callouts';
import {
    CHANGE_CONTACTS_DESKTOP_TYPE_EDIT_BANNERS,
    CHANGE_CONTACTS_MOBILE_TYPE_EDIT_BANNERS,
    CHANGE_MAIN_LINK_PROTOCOL,
    CHECK_BANNER_HREF_STATUS,
    CLEAR_MAIN_LINK_DOMAIN,
    SHOW_BANNERS_CONTACTS_VALIDATION_ERROR,
    UPDATE_BANNER_CONTACTS_FOR_USER,
    UPDATE_BANNER_CONTACTS_FOR_USER_DOMAIN,
    UPDATE_BANNER_DISPLAY_DOMAIN,
    UPDATE_BANNER_HREF_STATUS,
    UPDATE_HREF_BANNER_CONTACTS_FOR_USER,
    UPDATE_MAIN_LINK
} from '../actions/banners-edit/contacts';
import {
    ADD_MEASURER_VALUE,
    ADD_SHOWS_COUNTERS_ROW,
    CHANGE_MEASURER_VALUE,
    CHANGE_PIXEL_VALUE,
    CHANGE_SHOWS_COUNTERS_VALUE,
    CHANGE_TNS_ID_VALUE,
    DELETE_MEASURER,
    GET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS,
    REMOVE_SHOWS_COUNTERS_ROW,
    SET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS_ERROR,
    UPDATE_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS
} from '../actions/banners-edit/cpm-banner';
import { UPDATE_BANNERS_ORGANIZATION_IDS } from '../actions/banners-edit/organization';
import {
    CLOSE_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL,
    FETCH_PERFORMANCE_CREATIVES_ERROR,
    FETCH_PERFORMANCE_CREATIVES_START,
    FETCH_PERFORMANCE_CREATIVES_SUCCESS,
    OPEN_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL,
    PERFORMANCE_CREATIVE_REPLACE,
    PERFORMANCE_CREATIVES_CHANGE_DATE_SORT_ORDER,
    PERFORMANCE_CREATIVES_CHANGE_ID_OR_NAME,
    SELECT_PERFORMANCE_CREATIVES,
    SET_PERFORMANCE_CREATIVE_GROUP_CONSTRUCTOR,
    SET_PERFORMANCE_CREATIVE_ID_TO_REPLACE,
    SET_VISIBLE_PERFORMANCE_CHOOSE_CREATIVES_MODAL
} from '../actions/banners-edit/performanceCreatives';
import {
    CLOSE_BANNER_PRICE_EDITOR,
    CloseBannerPriceEditor,
    OPEN_BANNER_PRICE_EDITOR,
    OpenBannerPriceEditor,
    RESET_BANNER_DRAFT_PRICE,
    UPDATE_BANNER_PRICE_ERRORS,
    UpdateBannerPriceErrors,
    VALIDATE_BANNER_PRICE,
    VALIDATE_BANNER_PRICE_SUCCESS,
    ValidateBannerPrice,
    ValidateBannerPriceSuccess
} from '../actions/banners-edit/price';
import {
    CLOSE_RECOMMENDATIONS_FOR_BANNERS_EDIT,
    CloseRecommendationsForBannersEditAction,
    UPDATE_RECOMMENDATIONS_FOR_BANNERS_EDIT,
    UpdateRecommendationsForBannersEditAction
} from '../actions/banners-edit/recommendations';
import {
    BannerTurboGalleryActions,
    UPDATE_TURBO_GALLERY
} from '../actions/banners-edit/turbo-gallery';
import { UPDATE_BANNERS_PRICES_POPUP } from '../actions/banners-prices';
import {
    ADD_NEW_PERFORMANCE_BANNERS,
    ADD_NEW_TEXT_BANNERS,
    AddNewPerformanceBannersAction,
    AddNewTextBannersAction,
    CHANGE_BANNER_TYPE,
    ChangeBannerType,
    CLEAR_BANNERS,
    CLEAR_VISITING_CARD_FOR_EDIT_BANNERS,
    ClearBanners,
    ClearVisitingCardForEditBanners,
    CLOSE_INVALID_PROMOCODES_MODAL,
    CloseInvalidPromocodesModalAction,
    COPY_BANNER,
    CopyBanner,
    CREATE_NEW_CPM_BANNER,
    CREATE_NEW_MC_BANNER,
    CREATE_NEW_TEXT_BANNER,
    CreateNewCpmBannerAction,
    CreateNewMcBannerAction,
    CreateNewTextBannerAction,
    DELETE_BANNERS,
    DeleteBanners,
    EDIT_BANNER,
    GET_BANNERS_AUTO_GENERATED_VIDEO,
    GET_BANNERS_FOR_EDIT,
    GET_BASE_INFO_FOR_BANNER_CREATION,
    PREPARE_BANNERS_BEFORE_SAVING,
    RESET_BANNERS_EDIT,
    RESTORE_BANNERS,
    RestoreBanners,
    SAVE_BANNERS,
    SAVE_BANNERS_SUCCESS,
    SAVE_SUCCESS_VISITING_CARD_FOR_EDIT_BANNERS,
    SaveBannersSuccess,
    SaveSuccessVisitingCardForEditBanners,
    SHOW_BANNER_EDIT_REQUEST_ERROR,
    SHOW_BANNER_EDIT_SUMMARY_ERROR,
    SHOW_INVALID_BANNERS_PROMOCODES,
    ShowBannerEditSummaryError,
    ShowInvalidBannersPromocodes,
    UPDATE_BANNER_BASE_INFO,
    UPDATE_BANNERS_AUTO_GENERATED_VIDEO,
    UPDATE_BANNERS_EDIT_BASE_INFO_DATA,
    UPDATE_BANNERS_EDIT_GROUP_DATA_FOR_PERFORMANCE_CREATION,
    UPDATE_BANNERS_FOR_EDIT,
    UPDATE_LAST_ADDED_VCARD_IDS,
    UPDATE_VCARDS_FOR_EDIT,
    UpdateBannerBaseInfo,
    UpdateBannersAutoGeneratedVideo,
    UpdateBannersEditBaseInfoData,
    UpdateBannersEditGroupDataForPerformanceCreation,
    UpdateBannersForEdit,
    UpdateVCardsForEdit
} from '../actions/bannersEdit';
import {
    CLOSE_CREATIVE_CONSTRUCTOR,
    OPEN_CREATIVE_CONSTRUCTOR,
    OPEN_CREATIVE_CONSTRUCTOR_PRESETS,
    OPEN_CREATIVE_HTML5_ADD_CONSTRUCTOR,
    OPEN_CREATIVE_HTML5_CONSTRUCTOR,
    OPEN_CREATIVE_IDEAS,
    UPDATE_BANNER_CREATIVE_DATA,
    UPDATE_BANNER_CREATIVE_ID
} from '../actions/creative';
import { UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID } from '../actions/video';
import { TURBO_GALLERY_HREF_MAX_LENGTH } from '../constants';
import {
    getBannerContactsData,
    getEditedBannerCallouts,
    getEditedBannerImage,
    getEditedBannerSiteLinks,
    getEditedBannerVCard,
    getEditedBannerVideo,
    getGroupBannersList
} from '../mappers/banners-edit/api-data-mappers';
import { mapVisitingCardEditorValueToValue } from '../mappers/banners-edit/state-data-mappers/state-data-mappers';
import { mapGroupTypeToAdvType } from '../mappers/common/common';
import {
    selectBannersByCalloutsMassActions,
    selectBannersEditDataByDisplayedLinkReplace,
    selectBannersEditDataByLinkReplace,
    selectBannersEditDataByPartLinkReplace,
    selectBannersEditDataBySiteLinksReplace,
    selectBannersEditDataByTextReplace,
    selectBannersEditDataByTrackingParametersReplace,
    selectBannersEditPrices
} from '../selectors/bannerEdit/massActions/massActions';
import {
    bannerFieldErrorMapper,
    mapBannerPriceErrors
} from '../service/BannerEditErrors/BannerEditErrors';
import { bannersTextErrorMapper } from '../service/BannerEditErrors/ErrorsTextMapper/ErrorsTextMapper';
import { sitelinksErrorsTextMapper } from '../service/BannerEditErrors/SitelinksErrorsTextMapper/SitelinksErrorsTextMapper';
import { BannerIssue } from '../service/BannerEditValidation/helpers';
import {
    makeNewEditedBanner,
    makeNewPerformanceEditedBanner
} from '../service/BannerHelpers/BannerEditCreators';
import {
    generateNewBannerId,
    getBannerEditPageItemEditorId,
    getDefaultBannerPriceData,
    getDefaultEditedBannerPrice,
    getDefaultVCardData,
    isEditedBannerTypeCpmOutdoor,
    processBanners
} from '../service/BannerHelpers/BannerHelpers';
import { BannersIdsForBannersEditHelpers } from '../service/BannersIdsForBannersEditHelpers';
import {
    buildErrorTree,
    convertServerPathToClient,
    mapTextToErrors
} from '../service/ErrorsMapper/ErrorsMapper';
import {
    BannerId,
    BannersScreenUrlSearchQueryParams,
    SaveBannersResultData,
    VcardStatus
} from '../typings/banners';
import {
    DraftBanner,
    EditBannersState,
    EditedBanner,
    EditedBannerTypeCpcVideo,
    EditedBannerTypeImage,
    EditedBannerTypePerformance,
    EditedBannerTypeText,
    getEditedBannerWithCallouts,
    getEditedBannerWithPrice,
    getEditedBannerWithSitelinks,
    getEditedBannerWithTurboGallery,
    getEditedBannerWithVcard,
    GroupBanners,
    MassActionId,
    NewBannerInputData,
    NewPerformanceBannerInputData,
    PerformanceModalType
} from '../typings/bannersEditState';
import {
    ErrorsEdit,
    PageStatus,
    ValidationErrorData,
    ValidationErrorsData,
    ValidationResultItem
} from '../typings/common';
import { AdvType, AdvTypeClient, CampaignType } from '../typings/domain';
import {
    CurrencyCode,
    GdAdGroupPrimaryStatus,
    OrderInput
} from '../typings/graphql-grid';
import { State } from '../typings/state';

import { contactsReducer } from './banners-edit/contacts';
import { cpmBannerReducer } from './banners-edit/cpm-banner';
import { creativeReducer } from './banners-edit/creative';
import { bannersEditDisplayConditionsReducer } from './banners-edit/display-conditions';
import { organizationReducer } from './banners-edit/organization';
import { performanceCreativesReducer } from './banners-edit/performanceCreatives';
import { setSitelinksErrors } from './banners-edit/sitelinks';
import { videoReducer } from './banners-edit/video';

export interface EditBannerPageLocalAndUrlData {
    campaignsIds: string[];
    bannersIds: string[];
    groupsIds: string[];
    isNew: boolean;
}

export const getEditBannerPageData = (
    queryParams: Query
): EditBannerPageLocalAndUrlData => {
    const editBannersLocalData = BannersIdsForBannersEditHelpers.getBannersEditSessionValue(
        queryParams.ulogin
    );

    const editBannersDataFromUrl = {
        campaignsIds: queryParams[
            BannersScreenUrlSearchQueryParams.campaignsIds
        ]
            ? queryParams[BannersScreenUrlSearchQueryParams.campaignsIds].split(
                  ','
              )
            : [],
        bannersIds: queryParams[BannersScreenUrlSearchQueryParams.bannersIds]
            ? queryParams[BannersScreenUrlSearchQueryParams.bannersIds].split(
                  ','
              )
            : [],
        groupsIds: queryParams[BannersScreenUrlSearchQueryParams.groupsIds]
            ? queryParams[BannersScreenUrlSearchQueryParams.groupsIds].split(
                  ','
              )
            : [],
        isNew: queryParams[BannersScreenUrlSearchQueryParams.isNew]
            ? Boolean(+queryParams[BannersScreenUrlSearchQueryParams.isNew])
            : false
    };

    const hasNotEmptyBannersDataFromUrl =
        editBannersDataFromUrl.campaignsIds.length !== 0 ||
        editBannersDataFromUrl.groupsIds.length !== 0 ||
        editBannersDataFromUrl.bannersIds.length !== 0;

    return hasNotEmptyBannersDataFromUrl
        ? editBannersDataFromUrl
        : editBannersLocalData;
};

export const EditBannersInitialState: EditBannersState = {
    banners: {},
    bannersDraft: {},
    pageStatus: PageStatus.LOADING,
    groupBannersList: {},
    groupBannersRecommendations: {},
    campaignsIds: [],
    groupsIds: [],
    bannersIds: [],
    vCardsIds: {},
    isNew: false,
    constants: {
        ad: {
            maxLengthTurboGalleryHref: TURBO_GALLERY_HREF_MAX_LENGTH,
            maxLengthTitle: 0,
            maxLengthTitleWord: 0,
            maxLengthTitleExtension: 0,
            maxLengthBody: 0,
            maxLengthBodyWord: 0,
            narrowSymbols: '',
            allowAdLetters: '',
            maxNumberOfNarrowCharacters: 0,
            maxLengthHref: 0,
            maxLengthDisplayHref: 0,
            aggregationDomains: []
        },
        vcard: {
            companyNameMaxLength: 0,
            contactPersonMaxLength: 0,
            contactEmailMaxLength: 0,
            extraMessageMaxLength: 0,
            countryMaxLength: 0,
            cityMaxLength: 0,
            streetMaxLength: 0,
            houseWithBuildingMaxLength: 0,
            apartmentMaxLength: 0,
            instantMessengerLoginMaxLength: 0,
            countryCodeMaxLength: 0,
            cityCodeMaxLength: 0,
            phoneNumberMinLength: 0,
            phoneNumberMaxLength: 0,
            extensionMaxLength: 0,
            entirePhoneMinLength: 0,
            entirePhoneMaxLength: 0,
            entirePhoneWithExtensionMaxLength: 0
        },
        callouts: {
            calloutLettersAllowed: '',
            calloutTextMaxLength: 0,
            calloutsOnClientMaxCount: 0,
            calloutsOnClientMaxCountWithDeleted: 0,
            calloutsOnBannerMaxNumber: 0,
            calloutsStringMaxLength: 0,
            showCalloutsMaxNumber: 0
        },
        sitelinks: {
            allowSitelinkLetters: '',
            maxLengthSitelinkTitle: 0,
            maxLengthSitelinksTitle: 0,
            maxLengthSitelinkHref: 0,
            maxLengthSitelinkDescr: 0
        },
        canvas: {
            canvasDomain: '',
            turbolandingUnifiedApiUrl: ''
        }
    },
    clientInfo: {
        isBannerUpdateAllowed: false,
        isCpmBannerUpdateAllowed: false,
        isBannerPricesOnGridEnabled: false,
        isTycoonOrganizationsEnabled: false,
        isTurboForSerpWizardAllowed: false,
        clientId: '',
        workCurrency: CurrencyCode.RUB
    },
    errors: [],
    performanceCreatives: {
        isChooseModalOpen: false,
        isConstructorOpen: false,
        constructorType: undefined,
        constructorCreativeGroupId: undefined,
        selectedGroupCreatives: {},
        creativesAndGroupsList: [],
        creativeIds: [],
        creatives: {},
        creativeGroups: {},
        selectedCreatives: {},
        modalData: {
            type: PerformanceModalType.ADDITION,
            groupId: '',
            campaignId: ''
        },
        creativesLoading: false,
        creativesLoadedCount: 0,
        searchFieldByIdOrName: '',
        order: OrderInput.DESC,
        creativeIdToReplace: ''
    },
    isInvalidPromocodesModalOpen: false,
    invalidPromocodes: {},
    promocodes: {},
    canvasModal: {
        sharedData: {}
    },
    isGeneratedVideoLoading: false
};

export const ImageInitialState = getEditedBannerImage();

const getClearBannerDraft = (workCurrency: CurrencyCode): DraftBanner => ({
    vCard: {
        isShortVersionChecked: false,
        isNotShowMetroInSearchChecked: false,
        vCardStatus: VcardStatus.EDITING,
        info: getDefaultVCardData()
    }
});

const updateBannersForEdit = (
    state: EditBannersState,
    action: UpdateBannersForEdit
): EditBannersState => {
    const banners = action.data.banners || {};
    const workCurrency = state.clientInfo.workCurrency;
    return {
        ...state,
        banners: {
            ...banners
        },
        bannersDraft: Object.keys(banners).reduce((acc, bannerId) => {
            if (banners[bannerId].bannerType === AdvType.PERFORMANCE) {
                return acc;
            }

            acc[bannerId] = {
                ...getClearBannerDraft(workCurrency)
            };
            return acc;
        }, {}),
        constants: action.data.constants,
        groupBannersList: {
            ...action.data.groupBannersList
        },
        pageStatus: PageStatus.LOADED,
        clientInfo: {
            isBannerUpdateAllowed: get(
                action.data,
                'clientInfo.isBannerUpdateAllowed',
                false
            ),
            isCpmBannerUpdateAllowed: get(
                action.data,
                'clientInfo.isCpmBannerUpdateAllowed',
                false
            ),
            isBannerPricesOnGridEnabled: get(
                action.data,
                'clientInfo.isBannerPricesOnGridEnabled',
                false
            ),
            isTycoonOrganizationsEnabled: get(
                action.data,
                'clientInfo.isTycoonOrganizationsEnabled',
                false
            ),
            clientId: get(action.data, 'clientInfo.clientId'),
            workCurrency: get(action.data, 'clientInfo.workCurrency'),
            isTurboForSerpWizardAllowed: get(
                action.data,
                'clientInfo.isTurboForSerpWizardAllowed',
                false
            )
        },
        clientId: action.data.clientId,
        promocodes: action.data.promocodes,
        reqId: action.reqId
    };
};

const updateBannersEditBaseInfoData = (
    state: EditBannersState,
    action: UpdateBannersEditBaseInfoData
): EditBannersState => {
    return {
        ...state,
        constants: action.data.constants,
        clientInfo: {
            isBannerUpdateAllowed: get(
                action.data,
                'clientInfo.isBannerUpdateAllowed',
                false
            ),
            isCpmBannerUpdateAllowed: get(
                action.data,
                'clientInfo.isCpmBannerUpdateAllowed',
                false
            ),
            isBannerPricesOnGridEnabled: get(
                action.data,
                'clientInfo.isBannerPricesOnGridEnabled',
                false
            ),
            isTurboForSerpWizardAllowed: get(
                action.data,
                'clientInfo.isTurboForSerpWizardAllowed',
                false
            ),
            isTycoonOrganizationsEnabled: get(
                action.data,
                'clientInfo.isTycoonOrganizationsEnabled',
                false
            ),
            clientId: get(action.data, 'clientInfo.clientId'),
            workCurrency: get(action.data, 'clientInfo.workCurrency')
        },
        clientId: action.data.clientId,
        promocodes: action.data.promocodes,
        vCardsIds: action.data.vCardIds
    };
};

const validateBannerPriceReducer = processBanners(
    (
        banner: EditedBannerTypeText,
        draftBanner: DraftBanner,
        action: ValidateBannerPrice,
        index: number
    ) => {
        return {
            ...banner,
            bannerPriceEditor: {
                ...banner.bannerPriceEditor,
                isOnProgress: true,
                errors: undefined
            }
        };
    }
);

const validateBannerPriceSuccessReducer = processBanners<
    ValidateBannerPriceSuccess
>(
    (
        banner: EditedBannerTypeText,
        draftBanner: DraftBanner,
        action: ValidateBannerPriceSuccess,
        index: number,
        fullState
    ) => {
        return {
            ...banner,
            bannerPriceEditor: {
                ...banner.bannerPriceEditor,
                isOpen: false,
                isOnProgress: false,
                isHintHidden: true,
                bannerPrice: fullState.bannersPriceEditor[
                    action.bannerId[index]
                ].bannerPrice
                    ? fullState.bannersPriceEditor[action.bannerId[index]]
                          .bannerPrice
                    : getDefaultBannerPriceData(action.currency)
            }
        };
    }
);

const closeBannerPriceReducer = (
    state: EditBannersState,
    action: CloseBannerPriceEditor
): EditBannersState => {
    const banner = getEditedBannerWithPrice(state.banners[action.bannerId]);
    if (!banner) {
        return state;
    }

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.bannerId]: {
                ...banner,
                bannerPriceEditor: {
                    ...banner.bannerPriceEditor,
                    isOpen: false,
                    isOnProgress: false,
                    isHintHidden: true,
                    errors: []
                }
            }
        }
    };
};

const openBannerPriceReducer = (
    state: EditBannersState,
    action: OpenBannerPriceEditor
): EditBannersState => {
    const banner = getEditedBannerWithPrice(state.banners[action.bannerId]);
    if (!banner) {
        return state;
    }

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.bannerId]: {
                ...banner,
                bannerPriceEditor: {
                    ...banner.bannerPriceEditor,
                    bannerPrice: get(banner, 'bannerPriceEditor.bannerPrice'),
                    isOpen: true,
                    isOnProgress: false
                }
            }
        }
    };
};

const updateBannerPriceErrorsReducer = processBanners<UpdateBannerPriceErrors>(
    (
        banner: EditedBannerTypeText,
        draftBanner: DraftBanner,
        action: UpdateBannerPriceErrors,
        index: number
    ) => {
        return {
            ...banner,
            bannerPriceEditor: {
                ...banner.bannerPriceEditor,
                errors: mapBannerPriceErrors(action.errors[index]),
                isOnProgress: false
            }
        };
    }
);

const updateBaseBannerInfo = (
    state: EditBannersState,
    action: UpdateBannerBaseInfo
): EditBannersState => {
    const field =
        {
            mainTitle: 'title',
            additionalTitle: 'titleExtension',
            description: 'body'
        }[action.changed.field] || '';

    const banner = {
        ...state.banners[action.bannerId],
        [field]: action.changed.value
    };

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.bannerId]: {
                ...banner,
                errors: {
                    ...state.banners[action.bannerId].errors,
                    [field]: {
                        errors: []
                    }
                }
            }
        }
    };
};

const showInvalidBannersPromocodesReducer = (
    state: EditBannersState,
    action: ShowInvalidBannersPromocodes
): EditBannersState => {
    return {
        ...state,
        isInvalidPromocodesModalOpen: true,
        invalidPromocodes: action.promocodes
    };
};

const closeInvalidBannersPromocodesReducer = (
    state: EditBannersState,
    action: CloseInvalidPromocodesModalAction
): EditBannersState => {
    return {
        ...state,
        isInvalidPromocodesModalOpen: false,
        invalidPromocodes: {}
    };
};

const saveBanners = (state: EditBannersState): EditBannersState => {
    return {
        ...state,
        errorsSummary: {},
        errors: [],
        pageStatus: PageStatus.SAVING,
        isInvalidPromocodesModalOpen: false,
        invalidPromocodes: {}
    };
};

const fillStateWithBannerErrors = (
    errors: ValidationResultItem[],
    ids: BannerId[],
    state: EditBannersState
): EditBannersState => {
    const errorsClient = convertServerPathToClient(
        errors,
        bannerFieldErrorMapper
    );
    const errorsClientWithText = mapTextToErrors(
        errorsClient,
        bannersTextErrorMapper
    );
    const errorsTree: ErrorsEdit = buildErrorTree(errorsClientWithText);

    if (errorsTree.common) {
        state.errors = [...state.errors, ...errorsTree.common.errors];
    }

    Object.keys(errorsTree.banners || {}).forEach(key => {
        if (key === 'errors' && errorsTree.banners) {
            state.errors = [
                ...state.errors,
                ...(errorsTree.banners.errors as ValidationErrorData[])
            ];
        } else {
            const bannerId = ids[Number(key)];

            state = {
                ...state,
                banners: {
                    ...state.banners,
                    [bannerId]: {
                        ...state.banners[bannerId],
                        errors: get(errorsTree, `banners[${key}]`, [])
                    }
                }
            };
        }
    });

    return state;
};

const setSavedBanners = (
    state: EditBannersState,
    action: SaveBannersSuccess,
    fullState: State
): EditBannersState => {
    const {
        added,
        updated,
        smartAdded,
        cpmUpdated,
        cpmAdded,
        mcBannerUpdated,
        mcBannerAdded,
        deleted
    } = action.result;

    [updated, cpmUpdated, mcBannerUpdated].forEach(
        (updatedBanners: SaveBannersResultData) => {
            if (!updatedBanners.banners.length) {
                return;
            }

            const banners = { ...state.banners };

            updatedBanners.banners.forEach(updatedBanner => {
                if (!updatedBanner) {
                    return;
                }
                const id = String(updatedBanner.id);

                banners[id] = {
                    ...state.banners[id],
                    isSaved: true
                };
            });

            state = {
                ...state,
                banners
            };
        }
    );

    [cpmAdded, added, mcBannerAdded].forEach(
        (addedBanners: SaveBannersResultData) => {
            if (!addedBanners.banners.length) {
                return;
            }

            const banners = { ...state.banners };
            const bannersDraft = { ...state.bannersDraft };
            let bannersIds = [...state.bannersIds];
            const groupBannersList = { ...state.groupBannersList };

            addedBanners.banners.forEach((addedBanner, index) => {
                if (!addedBanner) {
                    return;
                }
                const oldId = addedBanners.ids[index];
                const bannerData = state.banners[oldId];
                const newId = String(addedBanner.id);
                const groupId = bannerData.group.id;
                const groupBannersIds = [
                    ...groupBannersList[groupId].bannersIds
                ];

                let readOnly = false;
                if (bannerData.bannerType === AdvType.CPM_OUTDOOR) {
                    readOnly =
                        bannerData.group.status !==
                        GdAdGroupPrimaryStatus.DRAFT;
                }

                banners[newId] = {
                    ...bannerData,
                    isNew: false,
                    id: newId,
                    isSaved: true,
                    readOnly
                };

                bannersDraft[newId] = {
                    ...bannersDraft[oldId]
                };

                if (groupBannersIds.includes(oldId)) {
                    groupBannersIds[groupBannersIds.indexOf(oldId)] = newId;
                    groupBannersList[groupId].bannersIds = groupBannersIds;
                }

                delete banners[oldId];
                delete bannersDraft[oldId];

                bannersIds = [...bannersIds, newId];
            });

            state = {
                ...state,
                banners
            };
        }
    );

    if (deleted.ids.length) {
        const banners = { ...state.banners };
        deleted.ids.forEach(deletedBannerId => {
            if (!deletedBannerId) {
                return;
            }

            banners[deletedBannerId] = {
                ...state.banners[deletedBannerId],
                isEditAllow: false
            };
        });

        state = {
            ...state,
            banners
        };
    }

    state = makeUnchangedPerformanceBannersAreSaved(state);

    [
        updated,
        added,
        cpmUpdated,
        cpmAdded,
        smartAdded,
        mcBannerAdded,
        mcBannerUpdated
    ].forEach((result: SaveBannersResultData) => {
        state = {
            ...fillStateWithBannerErrors(result.errors, result.ids, state)
        };
    });

    state = {
        ...state,
        pageStatus: PageStatus.LOADED
    };

    return state;
};

// Не новые и не измененные смарт объявления не передаются на сервер и нужно их отобразить "сохраненными"
// после нажатия на сохранения всех баннеров в случае ошибки сохранения какого-нибуть баннера.
// Для не измененных баннеров будет отображаться успешное сохранение.
const makeUnchangedPerformanceBannersAreSaved = (
    state: EditBannersState
): EditBannersState => {
    const banners = { ...state.banners };
    const bannersIds = [...state.bannersIds];

    bannersIds.forEach(bannerId => {
        const banner = banners[bannerId];

        if (
            banner !== undefined &&
            banner.bannerType === AdvType.PERFORMANCE &&
            !banner.isNew
        ) {
            banner.isSaved = true;
        }
    });

    return {
        ...state,
        banners
    };
};

export function addNewTextBanners(
    state: EditBannersState,
    action: AddNewTextBannersAction
): EditBannersState {
    let index: number = 0;
    const newBanners: Record<BannerId, EditedBanner> = action.banners.reduce(
        (
            result: Record<BannerId, EditedBanner>,
            newBanner: NewBannerInputData
        ) => {
            const group = state.groupBannersList[newBanner.groupId];

            const isNew = true;

            // флаг может быть undefined, тогда считаем, что для баннера нет промокода
            const isPromocodeActive =
                state.promocodes[newBanner.campaignId] !== undefined
                    ? true
                    : undefined;

            const id = newBanner.bannerData.id;

            result[id] = makeNewEditedBanner(
                newBanner.bannerType,
                id,
                isNew,
                {
                    id: group.groupId,
                    name: group.groupName,
                    status: group.status,
                    canEdit: group.canEdit,
                    type: group.type
                },
                group.campaign,
                state.clientInfo.workCurrency,
                isPromocodeActive,
                newBanner.bannerData,
                newBanner.vCardId,
                group.autoGeneratedVideo
            );

            index = index + 1;
            return result;
        },
        {}
    );

    return {
        ...state,
        banners: {
            ...state.banners,
            ...newBanners
        },
        bannersDraft: {
            ...state.bannersDraft,
            ...Object.keys(newBanners).reduce(
                (result: Record<BannerId, DraftBanner>, bannerId) => {
                    result[bannerId] = {
                        ...state.bannersDraft[bannerId]
                    };
                    return result;
                },
                {}
            )
        },
        groupBannersList: {
            ...Object.keys(newBanners).reduce(
                (result: Record<string, GroupBanners>, bannerId) => {
                    const groupId = newBanners[bannerId].group.id;

                    result[groupId] = {
                        ...state.groupBannersList[groupId],
                        bannersIds: [
                            ...state.groupBannersList[groupId].bannersIds,
                            newBanners[bannerId].id
                        ],
                        bannersTotal:
                            state.groupBannersList[groupId].bannersTotal + 1
                    };

                    return result;
                },
                state.groupBannersList
            )
        }
    };
}

export function createNewTextBanner(
    state: EditBannersState,
    action: CreateNewTextBannerAction
): EditBannersState {
    const bannersCountsMap = {};
    bannersCountsMap[action.group.id] = action.group.adsCount + 1; // считаем, что новое добавляемое объявление увеличивает счетчик

    const newBanners: Record<BannerId, EditedBanner> = {};

    const isNew = true;

    const isPromocodeActive =
        state.promocodes[action.campaign.id] !== undefined ? true : undefined;

    const id = action.bannerId;

    newBanners[id] = makeNewEditedBanner(
        AdvType.TEXT,
        id,
        isNew,
        {
            id: action.group.id,
            name: action.group.name,
            status: action.group.status,
            canEdit: action.group.canEdit,
            type: action.group.type
        },
        {
            id: action.campaign.id,
            name: action.campaign.name,
            platform: action.campaign.platform,
            type: action.campaign.type
        },
        state.clientInfo.workCurrency,
        isPromocodeActive,
        {},
        state.vCardsIds[action.campaign.id],
        action.video
    );

    return {
        ...state,
        banners: {
            ...newBanners
        },
        bannersDraft: {
            ...Object.keys(newBanners).reduce(
                (result: Record<BannerId, DraftBanner>, bannerId) => {
                    result[bannerId] = {
                        ...state.bannersDraft[bannerId]
                    };
                    return result;
                },
                {}
            )
        },
        pageStatus: PageStatus.LOADED,
        groupBannersList: {
            ...getGroupBannersList<GroupBanners>(
                newBanners,
                bannersCountsMap,
                action.video
            )
        }
    };
}

export function createNewMcBanner(
    state: EditBannersState,
    action: CreateNewMcBannerAction
): EditBannersState {
    const bannersCountsMap = {};
    bannersCountsMap[action.group.id] = action.group.adsCount + 1; // считаем, что новое добавляемое объявление увеличивает счетчик

    const newBanners: Record<BannerId, EditedBanner> = {};

    const isNew = true;

    const isPromocodeActive =
        state.promocodes[action.campaign.id] !== undefined ? true : undefined;

    const id = action.bannerId;

    newBanners[id] = makeNewEditedBanner(
        AdvType.MCBANNER,
        id,
        isNew,
        {
            id: action.group.id,
            name: action.group.name,
            status: action.group.status,
            canEdit: action.group.canEdit,
            type: action.group.type
        },
        {
            id: action.campaign.id,
            name: action.campaign.name,
            platform: action.campaign.platform,
            type: action.campaign.type
        },
        state.clientInfo.workCurrency,
        isPromocodeActive
    );

    return {
        ...state,
        banners: {
            ...newBanners
        },
        bannersDraft: {
            ...Object.keys(newBanners).reduce(
                (result: Record<BannerId, DraftBanner>, bannerId) => {
                    result[bannerId] = {
                        ...state.bannersDraft[bannerId]
                    };
                    return result;
                },
                {}
            )
        },
        pageStatus: PageStatus.LOADED,
        groupBannersList: {
            ...getGroupBannersList<GroupBanners>(newBanners, bannersCountsMap)
        }
    };
}

export function createNewCpmBanner(
    state: EditBannersState,
    action: CreateNewCpmBannerAction
): EditBannersState {
    const {
        group: { id: groupId, adsCount, type: groupType },
        campaign: { id: campaignId }
    } = action;
    const bannersCountsMap = {};
    bannersCountsMap[groupId] = adsCount + 1; // считаем, что новое добавляемое объявление увеличивает счетчик

    const newBanners: Record<BannerId, EditedBanner> = {};

    const id = generateNewBannerId(action.campaign.id, action.group.id);
    const isNew = true;

    const isPromocodeActive =
        state.promocodes[campaignId] !== undefined ? true : undefined;

    const type = mapGroupTypeToAdvType(groupType);

    newBanners[id] = makeNewEditedBanner(
        type,
        id,
        isNew,
        {
            id: action.group.id,
            name: action.group.name,
            status: action.group.status,
            canEdit: action.group.canEdit,
            type: action.group.type
        },
        {
            id: action.campaign.id,
            name: action.campaign.name,
            platform: action.campaign.platform,
            type: action.campaign.type
        },
        state.clientInfo.workCurrency,
        isPromocodeActive
    );

    return {
        ...state,
        banners: {
            ...newBanners
        },
        bannersDraft: {
            ...Object.keys(newBanners).reduce(
                (result: Record<BannerId, DraftBanner>, bannerId) => {
                    result[bannerId] = {
                        ...state.bannersDraft[bannerId]
                    };
                    return result;
                },
                {}
            )
        },
        pageStatus: PageStatus.LOADED,
        groupBannersList: {
            ...getGroupBannersList<GroupBanners>(newBanners, bannersCountsMap)
        }
    };
}

export function addNewPerformanceBanners(
    state: EditBannersState,
    action: AddNewPerformanceBannersAction
): EditBannersState {
    const newBanners: Record<BannerId, EditedBanner> = action.banners.reduce(
        (
            result: Record<BannerId, EditedBannerTypePerformance>,
            newBanner: NewPerformanceBannerInputData
        ) => {
            const group = state.groupBannersList[newBanner.groupId];
            const editGroup = {
                id: group.groupId,
                name: group.groupName,
                status: group.status,
                canEdit: group.canEdit,
                type: group.type
            };

            const id = generateNewBannerId(
                newBanner.campaignId,
                newBanner.groupId
            );

            const isNew = true;
            const bannerData = newBanner.bannerData;
            result[id] = makeNewPerformanceEditedBanner(
                id,
                editGroup,
                isNew,
                group.campaign,
                bannerData
            );

            return result;
        },
        {}
    );

    return {
        ...state,
        banners: {
            ...state.banners,
            ...newBanners
        },
        groupBannersList: {
            ...Object.keys(newBanners).reduce(
                (result: Record<string, GroupBanners>, bannerId) => {
                    const groupId = newBanners[bannerId].group.id;

                    result[groupId] = {
                        ...state.groupBannersList[groupId],
                        bannersIds: [
                            ...state.groupBannersList[groupId].bannersIds,
                            newBanners[bannerId].id
                        ],
                        bannersTotal:
                            state.groupBannersList[groupId].bannersTotal + 1
                    };

                    return result;
                },
                state.groupBannersList
            )
        },
        pageStatus: PageStatus.LOADED,
        performanceCreatives: {
            ...state.performanceCreatives,
            selectedCreatives: {}
        }
    };
}

export function updateGroupDataForPerformanceCreation(
    state: EditBannersState,
    action: UpdateBannersEditGroupDataForPerformanceCreation
): EditBannersState {
    const group = action.group;
    const campaign = action.campaign;

    const groupBanners: Record<string, GroupBanners> = {};
    groupBanners[group.id] = {
        groupId: group.id,
        bannersIds: [],
        groupName: group.name,
        campaign: {
            id: campaign.id,
            name: campaign.name,
            platform: campaign.platform,
            type: campaign.type
        },
        bannersTotal: group.adsCount,
        status: group.status,
        canEdit: group.canEdit,
        type: group.type
    };
    return {
        ...state,
        banners: {},
        bannersDraft: {},
        groupBannersList: {
            ...groupBanners
        },
        performanceCreatives: {
            ...state.performanceCreatives,
            selectedCreatives: {}
        }
    };
}

export function clearBanners(
    state: EditBannersState,
    action: ClearBanners
): EditBannersState {
    const banners = { ...state.banners };
    const bannersDraft = { ...state.bannersDraft };

    Object.keys(action.bannersToClear).forEach(bannerId => {
        const banner = banners[bannerId];
        const groupId = banner.group.id;
        const group = state.groupBannersList[groupId];

        banners[bannerId] = makeNewEditedBanner(
            banner.bannerType,
            banner.id,
            banner.isNew,
            {
                id: group.groupId,
                name: group.groupName,
                status: group.status,
                canEdit: group.canEdit,
                type: group.type
            },
            group.campaign,
            action.workCurrency,
            banner.isPromocodeActive,
            {
                canBeDeleted: banner.canBeDeleted
            }
        );

        bannersDraft[bannerId] = {
            ...getClearBannerDraft(action.workCurrency)
        };
    });

    return {
        ...state,
        banners,
        bannersDraft
    };
}

export function restoreBannersReducer(
    state: EditBannersState,
    action: RestoreBanners
): EditBannersState {
    const banners = { ...state.banners };

    action.bannersIds.forEach((bannerId: BannerId) => {
        banners[bannerId].markedForDeletion = false;
    });

    return {
        ...state,
        banners,

        groupBannersList: action.bannersIds.reduce(
            (result: Record<string, GroupBanners>, bannerId: BannerId) => {
                const groupId = banners[bannerId].group.id;

                result[groupId] = {
                    ...result[groupId],
                    bannersTotal: result[groupId].bannersTotal + 1
                };

                return result;
            },
            {
                ...state.groupBannersList
            }
        )
    };
}

export function copyBannerReducer(
    state: EditBannersState,
    action: CopyBanner
): EditBannersState {
    const dublicateBanner = cloneDeep(state.banners[action.bannerId]);
    const duplicateDraftBanner = cloneDeep(state.bannersDraft[action.bannerId]);

    const groupId = dublicateBanner.group.id;
    const groupBannersList = state.groupBannersList[groupId];

    if (!dublicateBanner && !duplicateDraftBanner) {
        throw new Error(
            `cannot find banner for duplicate id:${action.bannerId}`
        );
    }

    dublicateBanner.id = action.newBannerId;
    dublicateBanner.isNew = true;
    dublicateBanner.canBeDeleted = true;
    dublicateBanner.readOnly = false;
    dublicateBanner.errors = undefined;

    if (isEditedBannerTypeCpmOutdoor(dublicateBanner)) {
        dublicateBanner.operators = [];
        dublicateBanner.rejectReasons = undefined;
    }

    const bannerWithSitelinks = getEditedBannerWithSitelinks(dublicateBanner);

    if (bannerWithSitelinks) {
        (dublicateBanner as EditedBannerTypeText).sitelinks.isOpen = false;
    }

    const bannerWithPrice = getEditedBannerWithPrice(dublicateBanner);

    if (bannerWithPrice) {
        (dublicateBanner as EditedBannerTypeText).bannerPriceEditor.isOpen = false;
    }

    const bannerWithCallouts = getEditedBannerWithCallouts(dublicateBanner);

    if (bannerWithCallouts) {
        (dublicateBanner as EditedBannerTypeText).callouts.isEditorOpen = false;
    }

    dublicateBanner.errors = undefined;

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.newBannerId]: dublicateBanner
        },
        bannersDraft: {
            ...state.bannersDraft,
            [action.newBannerId]: duplicateDraftBanner
        },
        groupBannersList: {
            ...state.groupBannersList,
            [groupId]: {
                ...groupBannersList,
                bannersIds: [
                    ...groupBannersList.bannersIds,
                    action.newBannerId
                ],
                bannersTotal: groupBannersList.bannersTotal + 1
            }
        }
    };
}

export function showBannerEditSummaryError(
    state: EditBannersState,
    action: ShowBannerEditSummaryError,
    fullState: State
): EditBannersState {
    let newState = { ...state };

    Object.keys(action.error).forEach((bannerId: BannerId) => {
        action.error[bannerId].issues.forEach((issue: BannerIssue) => {
            switch (issue) {
                case BannerIssue.SITELINKS_OPENED:
                    newState = setSitelinksErrors(
                        newState,
                        [bannerId],
                        buildErrorTree(
                            mapTextToErrors(
                                [
                                    {
                                        code: 'NEED_TO_SAVE',
                                        path: 'sitelinks',
                                        params: null
                                    }
                                ],
                                sitelinksErrorsTextMapper
                            )
                        ),
                        fullState
                    );
                    break;
                default:
                // nothing
            }
        });
    });

    return {
        ...newState,
        errorsSummary: action.error,
        pageStatus: PageStatus.ERROR
    };
}

export function deleteBanners(
    state: EditBannersState,
    action: DeleteBanners
): EditBannersState {
    const banners = { ...state.banners };
    const bannersDraft = { ...state.bannersDraft };

    // сначала удаляем из groupBannersList id-шники баннеров
    const groupBannersList = action.bannersIds.reduce(
        (result: Record<string, GroupBanners>, bannerId: BannerId) => {
            const groupId = state.banners[bannerId].group.id;

            result[groupId] = {
                ...result[groupId],
                bannersIds: banners[bannerId].isNew
                    ? without(result[groupId].bannersIds, bannerId)
                    : result[groupId].bannersIds,
                bannersTotal: result[groupId].bannersTotal - 1
            };

            return result;
        },
        { ...state.groupBannersList }
    );

    // потом удаляем баннеры или помечаем их для удаления
    action.bannersIds.forEach((bannerId: BannerId) => {
        if (banners[bannerId].isNew) {
            delete banners[bannerId];
            delete bannersDraft[bannerId]; // удаляем bannersDraft только для новых объявлений, текущие можно будет восстановить
        } else {
            banners[bannerId].markedForDeletion = true;
        }
    });

    return {
        ...state,
        banners,
        bannersDraft,
        groupBannersList
    };
}

function migrateBannerFromTypeToType(
    toType: AdvType | AdvTypeClient,
    banner: EditedBanner,
    workCurrency: CurrencyCode = CurrencyCode.RUB
): EditedBanner {
    const fromType = banner.bannerType;

    switch (`${fromType} -> ${toType}`) {
        case `${AdvType.TEXT} -> ${AdvTypeClient.TEXT_MOBILE}`:
        case `${AdvType.IMAGE_AD} -> ${AdvTypeClient.TEXT_MOBILE}`:
        case `${AdvType.CPC_VIDEO} -> ${AdvTypeClient.TEXT_MOBILE}`:
            const tmpBannerForTextMobile = banner as EditedBannerTypeText;

            return {
                ...banner,
                title: tmpBannerForTextMobile.title || '',
                titleExtension: tmpBannerForTextMobile.titleExtension || '',
                body: tmpBannerForTextMobile.body || '',
                vCardId: tmpBannerForTextMobile.vCardId || '',
                vCard:
                    tmpBannerForTextMobile.vCard ||
                    getEditedBannerVCard(null, null, true),
                sitelinksSetId: tmpBannerForTextMobile.sitelinksSetId || null,
                sitelinks:
                    tmpBannerForTextMobile.sitelinks ||
                    getEditedBannerSiteLinks(),
                callouts:
                    tmpBannerForTextMobile.callouts ||
                    getEditedBannerCallouts(),
                video: tmpBannerForTextMobile.video || getEditedBannerVideo(),
                bannerPriceEditor:
                    tmpBannerForTextMobile.bannerPriceEditor ||
                    getDefaultEditedBannerPrice(workCurrency),
                bannerType: AdvTypeClient.TEXT_MOBILE,
                errors: undefined,
                contacts: getBannerContactsData(banner)
            } as EditedBannerTypeText;
        case `${AdvType.TEXT} -> ${AdvType.IMAGE_AD}`:
        case `${AdvTypeClient.TEXT_MOBILE} -> ${AdvType.IMAGE_AD}`:
        case `${AdvType.CPC_VIDEO} -> ${AdvType.IMAGE_AD}`:
            return {
                ...banner,
                bannerType: AdvType.IMAGE_AD,
                errors: undefined,
                contacts: getBannerContactsData(banner)
            } as EditedBannerTypeImage;
        case `${AdvTypeClient.TEXT_MOBILE} -> ${AdvType.TEXT}`:
        case `${AdvType.IMAGE_AD} -> ${AdvType.TEXT}`:
        case `${AdvType.CPC_VIDEO} -> ${AdvType.TEXT}`:
            const tmpBannerForText = banner as EditedBannerTypeText;

            return {
                ...banner,
                title: tmpBannerForText.title || '',
                titleExtension: tmpBannerForText.titleExtension || '',
                body: tmpBannerForText.body || '',
                vCardId: tmpBannerForText.vCardId || '',
                vCard:
                    tmpBannerForText.vCard ||
                    getEditedBannerVCard(null, null, true),
                sitelinksSetId: tmpBannerForText.sitelinksSetId || null,
                sitelinks:
                    tmpBannerForText.sitelinks || getEditedBannerSiteLinks(),
                callouts:
                    tmpBannerForText.callouts || getEditedBannerCallouts(),
                video: tmpBannerForText.video || getEditedBannerVideo(),
                bannerPriceEditor:
                    tmpBannerForText.bannerPriceEditor ||
                    getDefaultEditedBannerPrice(workCurrency),
                bannerType: AdvType.TEXT,
                errors: undefined,
                contacts: getBannerContactsData(banner)
            } as EditedBannerTypeText;
        case `${AdvTypeClient.TEXT_MOBILE} -> ${AdvType.CPC_VIDEO}`:
        case `${AdvType.TEXT} -> ${AdvType.CPC_VIDEO}`:
        case `${AdvType.IMAGE_AD} -> ${AdvType.CPC_VIDEO}`:
            const tmpBannerForVideo = banner as EditedBannerTypeCpcVideo;

            return {
                ...banner,
                video: tmpBannerForVideo.video || getEditedBannerVideo(),
                bannerType: AdvType.CPC_VIDEO,
                errors: undefined,
                contacts: getBannerContactsData(banner)
            } as EditedBannerTypeCpcVideo;
        default:
            throw new Error(
                `миграция объявления из ${fromType} в ${toType} не поддерживается`
            );
    }
}

const saveCallouts = (action: SaveCallouts, state: State): EditBannersState => {
    const { data } = state.calloutsEditor;

    const newBanners = action.bannerId.reduce(
        (acc, next) => {
            const banner = state.editBanners.banners[
                next
            ] as EditedBannerTypeText;

            const { selected } = data[next];
            acc[next] = {
                ...banner,
                callouts: {
                    ...banner.callouts,
                    selected,
                    isEditorOpen: false
                },
                errors: {
                    ...banner.errors,
                    callouts: {
                        errors: data[next].errors
                    }
                }
            };

            return acc;
        },
        {} as Record<BannerId, EditedBannerTypeText>
    );

    return {
        ...state.editBanners,
        banners: {
            ...state.editBanners.banners,
            ...newBanners
        }
    };
};

function changeBannerType(
    state: EditBannersState,
    action: ChangeBannerType,
    fullState: State
): EditBannersState {
    const banner = state.banners[action.bannerId];
    if (banner.campaign.type !== CampaignType.TEXT) {
        return state;
    }

    let workCurrency;
    if (fullState.commonData) {
        workCurrency = fullState.commonData.client.workCurrency;
    }

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.bannerId]: migrateBannerFromTypeToType(
                action.bannerType,
                banner,
                workCurrency
            )
        }
    };
}

function openSiteLinksEditor(
    state: EditBannersState,
    action: OpenSiteLinksEditor,
    fullState: State
): EditBannersState {
    const banner = getEditedBannerWithSitelinks(
        fullState.editBanners.banners[action.bannerId]
    );
    if (!banner) {
        return state;
    }

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.bannerId]: {
                ...banner,
                sitelinks: {
                    ...banner.sitelinks,
                    isOpen: true
                }
            }
        }
    };
}

const clearSitelinks = processBanners<ClearSiteLinks>(
    (
        banner: EditedBannerTypeText,
        draftBanner: DraftBanner,
        action: ClearSiteLinks,
        index: number,
        fullState: State
    ) => {
        const sitelinksBanner = getEditedBannerWithSitelinks(banner);

        if (!sitelinksBanner) {
            return banner;
        }

        return {
            ...sitelinksBanner,
            sitelinksSetId: null,
            sitelinks: {
                items: fullState.siteLinksEditor.data[banner.id].items,
                isOpen: false
            },
            errors: {
                ...sitelinksBanner.errors,
                sitelinks: {}
            }
        };
    }
);

const closeSiteLinksEditor = (
    state: EditBannersState,
    action: CloseSiteLinksEditor
): EditBannersState => {
    const banner = getEditedBannerWithSitelinks(state.banners[action.bannerId]);
    if (!banner) {
        return state;
    }

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.bannerId]: {
                ...banner,
                sitelinks: {
                    ...banner.sitelinks,
                    isOpen: false
                }
            }
        }
    };
};

const clearSiteLinksErrors = (
    state: EditBannersState,
    action: UpdateDraftSiteLinks
): EditBannersState => {
    const banner = getEditedBannerWithSitelinks(state.banners[action.bannerId]);
    if (!banner) {
        return state;
    }
    const errors: ValidationErrorsData = omit(banner.errors, [
        'sitelinks'
    ]) as ValidationErrorsData;

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.bannerId]: {
                ...banner,
                errors: {
                    ...errors
                }
            }
        }
    };
};

const saveSiteLinks = processBanners<SaveSiteLinksSuccess>(
    (
        banner: EditedBannerTypeText,
        draftBanner: DraftBanner,
        action: SaveSiteLinksSuccess,
        index: number
    ) => {
        const sitelinksBanner = getEditedBannerWithSitelinks(banner);

        if (!sitelinksBanner) {
            return banner;
        }

        return {
            ...banner,
            sitelinks: {
                items: [...action.collapsedSiteLinks[index]],
                isOpen: false
            },
            sitelinksSetId: action.sitelinksSetId[index]
        };
    }
);

const resetSiteLinks = (
    state: EditBannersState,
    action: ResetSiteLinks
): EditBannersState => {
    const banner = getEditedBannerWithSitelinks(state.banners[action.bannerId]);
    if (!banner) {
        return state;
    }

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.bannerId]: {
                ...banner,
                sitelinks: {
                    ...banner.sitelinks,
                    isOpen: false
                }
            }
        }
    };
};

const openCalloutsEditor = (
    state: EditBannersState,
    action: OpenCalloutsEditor
): EditBannersState => {
    const banner = getEditedBannerWithCallouts(state.banners[action.bannerId]);

    if (!banner) {
        return state;
    }

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.bannerId]: {
                ...banner,
                callouts: {
                    ...banner.callouts,
                    isEditorOpen: true
                }
            }
        }
    };
};

const closeBannerEditRecommendations = (
    state: EditBannersState,
    action: CloseRecommendationsForBannersEditAction
): EditBannersState => {
    const recommendation = state.groupBannersRecommendations[action.id];

    return {
        ...state,
        groupBannersRecommendations: {
            ...state.groupBannersRecommendations,
            [action.id]: {
                ...recommendation,
                isRecommendationsVisible: false
            }
        }
    };
};

const updateRecommendationData = (
    state: EditBannersState,
    action: UpdateRecommendationsForBannersEditAction
): EditBannersState => {
    return {
        ...state,
        groupBannersRecommendations: action.recommendations
    };
};

const closeCalloutsEditor = (
    state: EditBannersState,
    action: CloseCalloutsEditor
): EditBannersState => {
    const banner = getEditedBannerWithCallouts(state.banners[action.bannerId]);

    if (!banner) {
        return state;
    }

    return {
        ...state,
        banners: {
            ...state.banners,
            [action.bannerId]: {
                ...banner,
                callouts: {
                    ...banner.callouts,
                    isEditorOpen: false
                }
            }
        }
    };
};

const updateBannersAutoGeneratedVideo = (
    state: EditBannersState,
    action: UpdateBannersAutoGeneratedVideo
): EditBannersState => {
    const bannersData = Object.keys(state.groupBannersList).reduce(
        (acc, next: string) => {
            const video = action.video[next];
            const { bannersIds } = state.groupBannersList[next];

            acc.groupBannersList[next] = {
                ...state.groupBannersList[next],
                autoGeneratedVideo: video
            };

            bannersIds.forEach(bannerId => {
                if (
                    state.banners[bannerId].isNew &&
                    state.banners[bannerId].bannerType === AdvType.TEXT
                ) {
                    acc.banners[bannerId] = {
                        ...state.banners[bannerId],
                        video
                    };
                }
            });

            return acc;
        },
        {
            groupBannersList: {},
            banners: {}
        }
    );

    return {
        ...state,
        groupBannersList: bannersData.groupBannersList,
        banners: {
            ...state.banners,
            ...bannersData.banners
        },
        isGeneratedVideoLoading: false
    };
};

const updateTurboGallery = (
    state: EditBannersState,
    action: BannerTurboGalleryActions
): EditBannersState => {
    const banner = getEditedBannerWithTurboGallery(
        state.banners[action.bannerId]
    );
    if (!banner) {
        return state;
    }

    const { bannerId, turboGalleryHref } = action;
    const newBanner = produce(banner, (draft: Draft<EditedBannerTypeText>) => {
        draft.turboGallery.href = turboGalleryHref;
    });

    return produce(state, (draft: Draft<EditBannersState>) => {
        draft.banners[bannerId] = newBanner;
    });
};

export const updateVcardsForEdit = (
    state: EditBannersState,
    action: UpdateVCardsForEdit
): EditBannersState => {
    const bannersWithVCards = Object.keys(state.banners).reduce(
        (acc, bannerId) => {
            const tmpBanner = state.banners[bannerId];
            const banner = getEditedBannerWithVcard(tmpBanner);
            if (!banner) {
                return {
                    ...acc,
                    [bannerId]: tmpBanner
                };
            }

            return {
                ...acc,
                [bannerId]: {
                    ...banner,
                    vCard: {
                        ...banner.vCard,
                        info:
                            banner.vCard.info === undefined
                                ? action.vCards[banner.vCardId]
                                : banner.vCard.info,
                        isNotShowMetroInSearchChecked: banner.vCardId
                            ? get(action, `vCards[${banner.vCardId}]`, {})
                                  .metroStationId === '0'
                            : false
                    }
                }
            };
        },
        {}
    );

    return {
        ...state,
        banners: bannersWithVCards
    };
};

export const saveSuccessVisitingCardForEditBanners = (
    state: EditBannersState,
    action: SaveSuccessVisitingCardForEditBanners,
    fullState: State
): EditBannersState => {
    const { banners } = state;
    const { visitingCardEditor } = fullState;
    const { bannerIds, vCardIds } = action;

    const updateBanners: Record<BannerId, EditedBanner> = bannerIds.reduce(
        (acc: Record<BannerId, EditedBanner>, bannerId, index) => {
            const editorId = getBannerEditPageItemEditorId(bannerId);
            const currentBanner = getEditedBannerWithVcard(banners[bannerId]);
            const currentVisitingCard = visitingCardEditor[editorId];

            if (currentBanner && currentVisitingCard) {
                acc[bannerId] = {
                    ...currentBanner,
                    vCardId: vCardIds[index],
                    vCard: mapVisitingCardEditorValueToValue(
                        currentVisitingCard
                    )
                };
            }

            return acc;
        },
        {}
    );

    return {
        ...state,
        banners: {
            ...state.banners,
            ...updateBanners
        }
    };
};

export const clearVisitingCardForEditBanners = (
    state: EditBannersState,
    action: ClearVisitingCardForEditBanners
): EditBannersState => {
    const { banners } = state;
    const { bannerIds } = action;

    const updateBanners: Record<BannerId, EditedBanner> = bannerIds.reduce(
        (acc: Record<BannerId, EditedBanner>, bannerId, index) => {
            const currentBanner = getEditedBannerWithVcard(banners[bannerId]);

            if (currentBanner && currentBanner.vCard) {
                acc[bannerId] = {
                    ...currentBanner,
                    vCardId: '',
                    vCard: {
                        ...currentBanner.vCard,
                        info: getDefaultVCardData()
                    }
                };
            }

            return acc;
        },
        {}
    );

    return {
        ...state,
        banners: {
            ...state.banners,
            ...updateBanners
        }
    };
};

export function bannersMultiEdit(
    state: EditBannersState = EditBannersInitialState,
    action: Action,
    fullState: State
): EditBannersState {
    switch (action.type) {
        case RESET_BANNERS_EDIT:
            return EditBannersInitialState;
        case GET_BANNERS_FOR_EDIT:
            return {
                ...state,
                pageStatus: PageStatus.LOADING,
                errorsSummary: undefined,
                errors: []
            };
        case GET_BASE_INFO_FOR_BANNER_CREATION:
            return {
                ...state,
                pageStatus: PageStatus.LOADING,
                errorsSummary: undefined,
                errors: []
            };
        case UPDATE_BANNERS_FOR_EDIT:
            return updateBannersForEdit(state, action);
        case UPDATE_BANNERS_EDIT_BASE_INFO_DATA:
            return updateBannersEditBaseInfoData(state, action);
        case UPDATE_BANNER_BASE_INFO:
            return updateBaseBannerInfo(state, action);
        case EDIT_BANNER:
            return {
                ...state,
                banners: {
                    ...state.banners,
                    [action.bannerId]: {
                        ...state.banners[action.bannerId],
                        isSaved: false
                    }
                }
            };
        case SHOW_INVALID_BANNERS_PROMOCODES:
            return showInvalidBannersPromocodesReducer(state, action);
        case CLOSE_INVALID_PROMOCODES_MODAL:
            return closeInvalidBannersPromocodesReducer(state, action);
        case UPDATE_VCARDS_FOR_EDIT:
            return updateVcardsForEdit(state, action);
        case UPDATE_LAST_ADDED_VCARD_IDS:
            return {
                ...state,
                vCardsIds: action.vCardIds
            };
        case PREPARE_BANNERS_BEFORE_SAVING:
        case SAVE_BANNERS:
            return saveBanners(state);
        case SAVE_BANNERS_SUCCESS:
            return setSavedBanners(state, action, fullState);
        case SHOW_BANNER_EDIT_SUMMARY_ERROR:
            return showBannerEditSummaryError(state, action, fullState);
        case SHOW_BANNER_EDIT_REQUEST_ERROR:
            return {
                ...state,
                errors: [...state.errors, action.error],
                pageStatus: PageStatus.ERROR
            };
        case CHANGE_BANNER_TYPE:
            return changeBannerType(state, action, fullState);

        case ADD_NEW_TEXT_BANNERS:
            return addNewTextBanners(state, action);
        case CREATE_NEW_TEXT_BANNER:
            return createNewTextBanner(state, action);
        case CREATE_NEW_MC_BANNER:
            return createNewMcBanner(state, action);
        case CREATE_NEW_CPM_BANNER:
            return createNewCpmBanner(state, action);
        case UPDATE_BANNERS_EDIT_GROUP_DATA_FOR_PERFORMANCE_CREATION:
            return updateGroupDataForPerformanceCreation(state, action);
        case ADD_NEW_PERFORMANCE_BANNERS:
            return addNewPerformanceBanners(state, action);
        case DELETE_BANNERS:
            return deleteBanners(state, action);
        case CLEAR_BANNERS:
            return clearBanners(state, action);
        case RESTORE_BANNERS:
            return restoreBannersReducer(state, action);
        case COPY_BANNER:
            return copyBannerReducer(state, action);

        case OPEN_CREATIVE_CONSTRUCTOR:
        case OPEN_CREATIVE_CONSTRUCTOR_PRESETS:
        case OPEN_CREATIVE_HTML5_ADD_CONSTRUCTOR:
        case OPEN_CREATIVE_HTML5_CONSTRUCTOR:
        case OPEN_CREATIVE_IDEAS:
        case UPDATE_BANNER_CREATIVE_ID:
        case UPDATE_BANNER_CREATIVE_DATA:
        case CLOSE_CREATIVE_CONSTRUCTOR:
            return creativeReducer(state, action, fullState);

        // video
        case UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID:
            return videoReducer(state, action, fullState);

        case UPDATE_HREF_BANNER_CONTACTS_FOR_USER:
        case UPDATE_BANNER_CONTACTS_FOR_USER_DOMAIN:
        case UPDATE_BANNER_CONTACTS_FOR_USER:
        case CHECK_BANNER_HREF_STATUS:
        case UPDATE_BANNER_HREF_STATUS:
        case SHOW_BANNERS_CONTACTS_VALIDATION_ERROR:
        case UPDATE_MAIN_LINK:
        case CHANGE_MAIN_LINK_PROTOCOL:
        case CLEAR_MAIN_LINK_DOMAIN:
        case UPDATE_BANNER_DISPLAY_DOMAIN:
        case CHANGE_CONTACTS_DESKTOP_TYPE_EDIT_BANNERS:
        case CHANGE_CONTACTS_MOBILE_TYPE_EDIT_BANNERS:
        case ON_ACCEPT_MASS_ACTIONS_TURBOLANDING_BULK_REPLACEMENT_EDITOR:
            return contactsReducer(state, action, fullState);
        case UPDATE_BANNERS_ORGANIZATION_IDS:
            return organizationReducer(state, action);
        case SET_VISIBLE_PERFORMANCE_CHOOSE_CREATIVES_MODAL:
        case OPEN_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL:
        case CLOSE_PERFORMANCE_CREATIVES_CONSTRUCTOR_MODAL:
        case FETCH_PERFORMANCE_CREATIVES_START:
        case FETCH_PERFORMANCE_CREATIVES_SUCCESS:
        case FETCH_PERFORMANCE_CREATIVES_ERROR:
        case SELECT_PERFORMANCE_CREATIVES:
        case PERFORMANCE_CREATIVES_CHANGE_DATE_SORT_ORDER:
        case PERFORMANCE_CREATIVES_CHANGE_ID_OR_NAME:
        case SET_PERFORMANCE_CREATIVE_GROUP_CONSTRUCTOR:
        case SET_PERFORMANCE_CREATIVE_ID_TO_REPLACE:
        case PERFORMANCE_CREATIVE_REPLACE:
            return performanceCreativesReducer(state, action);
        case GET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS:
        case UPDATE_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS:
        case SET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS_ERROR:
        case CHANGE_PIXEL_VALUE:
        case CHANGE_SHOWS_COUNTERS_VALUE:
        case CHANGE_MEASURER_VALUE:
        case REMOVE_SHOWS_COUNTERS_ROW:
        case ADD_SHOWS_COUNTERS_ROW:
        case ADD_MEASURER_VALUE:
        case DELETE_MEASURER:
        case CHANGE_TNS_ID_VALUE:
            return cpmBannerReducer(state, action);
        case ON_ACCEPT_MASS_ACTIONS_COUNTERS_BULK_REPLACEMENT_EDITOR:
            const {
                isCpmVideoSeveralPixelsEnabled
            } = fullState.commonData.features;

            return Object.keys(state.banners).reduce(
                (acc, bannerId: BannerId) => {
                    const banner = acc.banners[bannerId];
                    const avalibleType: Set<AdvType | AdvTypeClient> = new Set([
                        AdvType.CPM_BANNER,
                        AdvType.CPM_VIDEO,
                        AdvType.CPM_AUDIO
                    ]);

                    if (!avalibleType.has(banner.bannerType)) {
                        return acc;
                    }

                    const massActionData =
                        fullState.bannersEditMassActions[action.massActionId]
                            .data;

                    return {
                        ...acc,
                        banners: {
                            ...acc.banners,
                            [bannerId]: {
                                ...banner,
                                showsCounters: massActionData.counters.slice(
                                    0,
                                    banner.bannerType === AdvType.CPM_VIDEO &&
                                        !isCpmVideoSeveralPixelsEnabled
                                        ? 1
                                        : massActionData.counters.length
                                )
                            }
                        }
                    };
                },
                { ...state } as EditBannersState
            );
        case ON_ACCEPT_MASS_ACTIONS_PIXEL_BULK_REPLACEMENT_EDITOR:
            return Object.keys(state.banners).reduce(
                (acc, bannerId: BannerId) => {
                    const banner = acc.banners[bannerId];

                    if (banner.bannerType !== AdvType.CPM_BANNER) {
                        return acc;
                    }

                    return {
                        ...acc,
                        banners: {
                            ...acc.banners,
                            [bannerId]: {
                                ...banner,
                                pixel:
                                    fullState.bannersEditMassActions[
                                        action.massActionId
                                    ].data.pixel
                            }
                        }
                    };
                },
                { ...state } as EditBannersState
            );
        case SAVE_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR:
            return {
                ...state,
                banners: selectBannersEditDataByLinkReplace(
                    fullState,
                    action.domain
                )
            };
        case SAVE_MASS_ACTIONS_TEXT_BULK_REPLACEMENT_EDITOR:
            return {
                ...state,
                banners: selectBannersEditDataByTextReplace(fullState)
            };
        case SAVE_MASS_ACTIONS_LINK_BULK_PATH_REPLACEMENT_EDITOR:
            return {
                ...state,
                banners: selectBannersEditDataByPartLinkReplace(
                    fullState,
                    action.domains
                )
            };
        case ACCEPT_MASS_ACTIONS_SITE_LINKS_EDITOR:
            return {
                ...state,
                banners: selectBannersEditDataBySiteLinksReplace(fullState)
            };
        case ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR:
            return {
                ...state,
                banners: selectBannersEditDataByTrackingParametersReplace(
                    fullState
                )
            };
        case ACCEPT_MASS_ACTIONS_LINK_DISPLAYED_BULK_REPLACEMENT_EDITOR:
            return {
                ...state,
                banners: selectBannersEditDataByDisplayedLinkReplace(fullState)
            };
        case OPEN_SITE_LINKS_EDITOR:
            return openSiteLinksEditor(state, action, fullState);
        case SHOW_SITE_LINKS_ERRORS:
            return setSitelinksErrors(
                state,
                action.bannerId,
                action.errors.map(error =>
                    buildErrorTree(
                        mapTextToErrors(error, sitelinksErrorsTextMapper)
                    )
                ),
                fullState,
                action.collapsedSiteLinks
            );

        case SHOW_BANNER_IMAGE_LINK_INPUT:
        case UPDATE_BANNER_IMAGE:
        case SHOW_BANNER_IMAGE_CREATIVE_UPLOAD_ERROR:
        case UPLOAD_AD_BANNER_IMAGES:
        case UPDATE_BANNER_IMAGE_BY_GALLERY:
        case UPDATE_BANNER_IMAGE_CREATIVE:
            if (action.bannerId === MassActionId.bannersEdit) {
                return state;
            }

            return {
                ...state,
                banners: {
                    ...state.banners,
                    [action.bannerId]: {
                        ...state.banners[action.bannerId],
                        errors: undefined
                    }
                }
            };

        case UPDATE_DRAFT_SITE_LINKS:
            if (action.bannerId === MassActionId.bannersEdit) {
                return state;
            }

            return clearSiteLinksErrors(state, action);
        case CLOSE_SITE_LINKS_EDITOR:
            return closeSiteLinksEditor(state, action);
        case CLEAR_SITE_LINKS:
            return clearSitelinks(state, action, fullState);
        case SAVE_SITE_LINKS_SUCCESS:
            return saveSiteLinks(state, action, fullState);
        case RESET_SITE_LINKS:
            return resetSiteLinks(state, action);
        case ON_ACCEPT_MASS_ACTIONS_BANNERS_PRICE:
            return {
                ...state,
                banners: selectBannersEditPrices(fullState)
            };
        case RESET_BANNER_DRAFT_PRICE: {
            const banner = getEditedBannerWithPrice(
                state.banners[action.bannerId]
            );
            if (!banner) {
                return state;
            }

            return {
                ...state,
                banners: {
                    ...state.banners,
                    [action.bannerId]: {
                        ...banner,
                        bannerPriceEditor: {
                            ...banner.bannerPriceEditor,
                            errors: []
                        }
                    }
                }
            };
        }

        case UPDATE_BANNERS_PRICES_POPUP: {
            if (
                action.bannerId === MassActionId.bannersEdit ||
                action.bannerId === MassActionId.bannerGrid
            ) {
                return state;
            }

            const banner = getEditedBannerWithPrice(
                state.banners[action.bannerId]
            );
            if (!banner) {
                return state;
            }

            return {
                ...state,
                banners: {
                    ...state.banners,
                    [action.bannerId]: {
                        ...banner,
                        bannerPriceEditor: {
                            ...banner.bannerPriceEditor,
                            errors: get(
                                banner,
                                'bannerPriceEditor.errors',
                                []
                            ).filter(
                                (error: ValidationResultItem): boolean => {
                                    // ошибки error.path = '', удаляются всегда
                                    if (!error.path) {
                                        return false;
                                    }

                                    return action.paths
                                        ? !action.paths.includes(error.path)
                                        : true;
                                }
                            )
                        }
                    }
                }
            };
        }

        case VALIDATE_BANNER_PRICE:
            return validateBannerPriceReducer(state, action, fullState);

        case VALIDATE_BANNER_PRICE_SUCCESS:
            return validateBannerPriceSuccessReducer(state, action, fullState);

        case CLOSE_BANNER_PRICE_EDITOR:
            return closeBannerPriceReducer(state, action);

        case OPEN_BANNER_PRICE_EDITOR:
            return openBannerPriceReducer(state, action);

        case UPDATE_BANNER_PRICE_ERRORS:
            return updateBannerPriceErrorsReducer(state, action, fullState);
        case SAVE_CALLOUTS:
            return saveCallouts(action, fullState);
        case OPEN_CALLOUTS_EDITOR:
            return openCalloutsEditor(state, action);
        case CLOSE_CALLOUTS_EDITOR:
            return closeCalloutsEditor(state, action);
        case ACCEPT_MASS_ACTIONS_CALLOUTS:
            return {
                ...state,
                banners: selectBannersByCalloutsMassActions(fullState)
            };
        case SAVE_SUCCESS_VISITING_CARD_FOR_EDIT_BANNERS:
            return saveSuccessVisitingCardForEditBanners(
                state,
                action,
                fullState
            );
        case CLEAR_VISITING_CARD_FOR_EDIT_BANNERS:
            return clearVisitingCardForEditBanners(state, action);
        case UPDATE_BANNERS_AUTO_GENERATED_VIDEO:
            return updateBannersAutoGeneratedVideo(state, action);
        case GET_BANNERS_AUTO_GENERATED_VIDEO:
            return {
                ...state,
                isGeneratedVideoLoading: true
            };
        case CLOSE_RECOMMENDATIONS_FOR_BANNERS_EDIT:
            return closeBannerEditRecommendations(state, action);
        case UPDATE_RECOMMENDATIONS_FOR_BANNERS_EDIT:
            return updateRecommendationData(state, action);
        case UPDATE_TURBO_GALLERY:
            return updateTurboGallery(state, action);
        case ON_CHANGE_OPEN_STATE_DISPLAY_CONDITIONS:
        case ON_START_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS:
        case ON_CHANGE_TEXT_TYPE_VIEW_DISPLAY_CONDITIONS:
        case ON_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS:
        case ON_ERROR_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS:
        case CHANGE_COPIED_DISPLAY_CONDITIONS_TOOLTIP_STATUS:
            return bannersEditDisplayConditionsReducer(state, action);
        default:
            return state;
    }
}
